(function () {
  const SELECTORS = {
    banner: "#custom-cookie-banner",
    settings: "#custom-cookie-settings",

    accept: "[data-cookie-accept]",

    settingsOpen: "[data-cookie-settings]",
    settingsClose: "[data-cookie-settings-close]",

    save: "[data-cookie-save]",
    settingsAccept: "[data-cookie-settings-accept]",

    analytics: "#cookie-analytics",
    marketing: "#cookie-marketing",
    preferences: "#cookie-preferences"
  };


  function initCookieBanner() {
    const banner = document.querySelector(SELECTORS.banner);
    const settings = document.querySelector(SELECTORS.settings);

    if (!banner || !settings) {
      return;
    }

    if (
      !window.Shopify ||
      typeof window.Shopify.loadFeatures !== "function"
    ) {
      console.error(
        "Shopify Customer Privacy API is unavailable."
      );

      return;
    }


    /*
     * Load Shopify's official consent tracking API.
     */
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1"
        }
      ],
      function (error) {

        if (error) {
          console.error(
            "Could not load Shopify consent API:",
            error
          );

          return;
        }

        const privacy = window.Shopify.customerPrivacy;

        if (!privacy) {
          console.error(
            "Shopify customerPrivacy object is unavailable."
          );

          return;
        }

        setupCookieBanner(
          privacy,
          banner,
          settings
        );
      }
    );
  }


  function setupCookieBanner(
    privacy,
    banner,
    settings
  ) {

    const acceptButton =
      banner.querySelector(SELECTORS.accept);

    const settingsButton =
      banner.querySelector(SELECTORS.settingsOpen);

    const settingsCloseButtons =
      settings.querySelectorAll(SELECTORS.settingsClose);

    const saveButton =
      settings.querySelector(SELECTORS.save);

    const settingsAcceptButton =
      settings.querySelector(SELECTORS.settingsAccept);

    const analyticsCheckbox =
      settings.querySelector(SELECTORS.analytics);

    const marketingCheckbox =
      settings.querySelector(SELECTORS.marketing);

    const preferencesCheckbox =
      settings.querySelector(SELECTORS.preferences);


    /*
     * -------------------------------------------------------
     * DETERMINE WHETHER THE BANNER SHOULD BE SHOWN
     * -------------------------------------------------------
     */

    const currentConsent =
      privacy.currentVisitorConsent();

    /*
     * Shopify returns:
     *
     * "yes" = allowed
     * "no"  = denied
     * ""    = no decision yet
     *
     * Therefore BOTH accepting and rejecting count
     * as having made a choice.
     */

    const hasMadeChoice =
      currentConsent.analytics !== "" ||
      currentConsent.marketing !== "" ||
      currentConsent.preferences !== "";


    /*
     * Shopify determines whether consent is required
     * for this visitor/region.
     */

    if (
      privacy.shouldShowBanner() &&
      !hasMadeChoice
    ) {
      showBanner();
    } else {
      hideBanner();
    }


    /*
     * -------------------------------------------------------
     * ACCEPT ALL
     * -------------------------------------------------------
     */

    acceptButton?.addEventListener(
      "click",
      function () {

        setConsent({
          analytics: true,
          marketing: true,
          preferences: true
        });

      }
    );


    /*
     * -------------------------------------------------------
     * OPEN SETTINGS
     * -------------------------------------------------------
     */

    settingsButton?.addEventListener(
      "click",
      function () {

        populateCurrentConsent();

        openSettings();

      }
    );


    /*
     * -------------------------------------------------------
     * SAVE INDIVIDUAL SELECTION
     * -------------------------------------------------------
     *
     * IMPORTANT:
     *
     * If all three switches are OFF,
     * this records:
     *
     * analytics   = false
     * marketing   = false
     * preferences = false
     *
     * This therefore acts as "Reject all".
     */

    saveButton?.addEventListener(
      "click",
      function () {

        setConsent({
          analytics:
            analyticsCheckbox?.checked === true,

          marketing:
            marketingCheckbox?.checked === true,

          preferences:
            preferencesCheckbox?.checked === true
        });

      }
    );


    /*
     * -------------------------------------------------------
     * ACCEPT ALL FROM SETTINGS
     * -------------------------------------------------------
     */

    settingsAcceptButton?.addEventListener(
      "click",
      function () {

        setConsent({
          analytics: true,
          marketing: true,
          preferences: true
        });

      }
    );


    /*
     * -------------------------------------------------------
     * CLOSE SETTINGS WITHOUT SAVING
     * -------------------------------------------------------
     */

    settingsCloseButtons.forEach(
      function (button) {

        button.addEventListener(
          "click",
          closeSettings
        );

      }
    );


    /*
     * ESC closes settings without changing consent.
     */

    document.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key === "Escape" &&
          !settings.hidden
        ) {
          closeSettings();
        }

      }
    );


    /*
     * -------------------------------------------------------
     * SAVE CONSENT THROUGH SHOPIFY
     * -------------------------------------------------------
     */

    function setConsent(consent) {

      privacy.setTrackingConsent(
        consent,
        function () {

          /*
           * Shopify has now persisted the visitor's
           * consent decision.
           */

          console.log(
            "Shopify consent saved:",
            privacy.currentVisitorConsent()
          );


          /*
           * Useful for debugging / verifying that Shopify
           * generated a consent identifier.
           */

          if (
            typeof privacy.consentId === "function"
          ) {
            console.log(
              "Shopify consent ID:",
              privacy.consentId()
            );
          }


          /*
           * Close both interfaces after successful save.
           */

          hideBanner();
          closeSettings();

        }
      );
    }


    /*
     * -------------------------------------------------------
     * POPULATE SETTINGS
     * -------------------------------------------------------
     */

    function populateCurrentConsent() {

      const consent =
        privacy.currentVisitorConsent();


      /*
       * A new visitor normally has an empty value.
       *
       * Empty !== "yes", so all optional categories
       * default to OFF.
       */

      if (analyticsCheckbox) {
        analyticsCheckbox.checked =
          consent.analytics === "yes";
      }

      if (marketingCheckbox) {
        marketingCheckbox.checked =
          consent.marketing === "yes";
      }

      if (preferencesCheckbox) {
        preferencesCheckbox.checked =
          consent.preferences === "yes";
      }
    }


    /*
     * -------------------------------------------------------
     * UI HELPERS
     * -------------------------------------------------------
     */

    function showBanner() {
      banner.hidden = false;
    }


    function hideBanner() {
      banner.hidden = true;
    }


    function openSettings() {
      settings.hidden = false;

      document.documentElement.style.overflow =
        "hidden";
    }


    function closeSettings() {
      settings.hidden = true;

      document.documentElement.style.overflow =
        "";
    }
  }


  /*
   * Wait until the theme DOM exists.
   */

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      initCookieBanner
    );

  } else {

    initCookieBanner();

  }
})();